import React, { useState, useRef, useContext } from "react"
import styled from "styled-components"
import { IconButton } from "@zendeskgarden/react-buttons"
import MenuStroke from "@zendeskgarden/svg-icons/src/16/menu-stroke.svg"
import SearchStroke from "@zendeskgarden/svg-icons/src/16/search-stroke.svg"
import XStroke from "@zendeskgarden/svg-icons/src/16/x-stroke.svg"
import { collections } from "../../lib/prop-types"
import LogoLink from "./logoLink"
import MobileDropdown from "./mobileDropdown"
import SearchModal from "../search/searchModal"
import SearchModalContext from "../search/searchModalContext"

const Container = styled.header`
  position: relative;
  z-index: 10;
  box-shadow: ${({ theme }) =>
    theme.shadows.lg(
      `${theme.space.base * 4}px`,
      `${theme.space.base * 6}px`,
      theme.colors.header.shadow
    )};
  ${props =>
    props.navOpen &&
    `position: fixed;
     background-color: ${props.theme.colors.header.mobileBackdrop};
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     z-index: 2;
  `}
`

const HeaderGrid = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.space.sm};
  grid-template-areas: "menu logo search";
  grid-template-columns: min-content 1fr min-content;
  align-items: center;
  justify-items: center;
  padding: ${props => props.theme.space.xs} ${props => props.theme.space.sm};
  background-color: ${props => props.theme.colors.header.background};
`

const SearchIcon = styled(SearchStroke)`
  color: ${props => props.theme.colors.header.mobileSearchToggle};
`

const MenuIcon = styled(MenuStroke)`
  color: ${props => props.theme.colors.header.mobileNavToggle};
`

const XIcon = styled(XStroke)`
  color: ${props => props.theme.colors.header.mobileNavToggle};
`

const Mobile = ({ collection }) => {
  const { openSearchModal, setOpenSearchModal } = useContext(SearchModalContext)
  const [navOpen, setNavOpen] = useState(false)
  const NavIcon = navOpen ? XIcon : MenuIcon
  const navToggle = useRef(null)

  return (
    <Container navOpen={navOpen} onClick={() => setNavOpen(false)}>
      <HeaderGrid onClick={e => e.stopPropagation()}>
        <IconButton
          ref={navToggle}
          data-testid="dev-docs-header-nav-toggle"
          aria-label={navOpen ? "Close navigation" : "Open navigation"}
          onClick={() => setNavOpen(!navOpen)}
        >
          <NavIcon aria-hidden="true" />
        </IconButton>
        <LogoLink to="/" width={175} />
        <IconButton
          aria-label="Open search modal"
          onClick={() => setOpenSearchModal(true)}
        >
          <SearchIcon aria-hidden="true" />
        </IconButton>
      </HeaderGrid>
      {navOpen && (
        <MobileDropdown
          collection={collection}
          closeDropdown={() => {
            navToggle.current.focus()
            setNavOpen(false)
          }}
        />
      )}

      {openSearchModal && (
        <SearchModal
          closeModal={() => {
            setOpenSearchModal(false)
          }}
          collection={collection}
        />
      )}
    </Container>
  )
}

Mobile.propTypes = {
  collection: collections.isRequired
}

export default Mobile
